import React, {useState, useEffect, useCallback} from 'react';
import api from '../contexts/BaseUrl'
import './DailyExpense.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { useContext } from "react";
import { UnitShadeContext } from "../contexts/UnitShadeContext";


function DailyExpense(){

    const { unitShadeNo } = useContext(UnitShadeContext);
    const token = JSON.parse(localStorage.getItem('auth')).token;
    const userRole = JSON.parse(localStorage.getItem('auth')).role;

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);


    const [allExpenseType,setAllExpenseType] = useState([]);
    const [expenseType,setExpenseType] = useState("");
    const [expenseTypeParams,setExpenseTypeParams] = useState("");

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

   

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');
    

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    
    const [assignedTo, setAssignedTo] = useState('');
    const [totalPrice,setTotalPrice] = useState();

    
  
    var url;

    if( dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        if(expenseTypeParams.length > 1){
            url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }  
    }
    else if(dateFromObj != null && dateToObj != null){
        if(expenseTypeParams.length > 1){
            url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }   
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        
        if(expenseTypeParams.length > 1){
            url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }
        
    }
    else if(dateFromObj != null){
        if(expenseTypeParams.length > 1){
            url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `expenses/get-expenses-by-type?&unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }   
    }
    else if(searchSalesAssignedTo.length>0){
        if(expenseTypeParams.length > 1){
            url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&expenseDescription=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
        }  
    }
    else if(expenseTypeParams.length > 0){   
        url = `expenses/get-expenses-by-type?expenseType=${expenseTypeParams}&unitShadeId=${unitShadeNo}&pageNumber=${pageNumber}&pageSize=40`
    }
    else{
        url = `expenses/get-expenses-by-type?unitShadeId=${unitShadeNo}&pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllDailyExpenses = useCallback( async () => {
        setIsLoading(true);
        
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
        
    },[url, token])

    const fetchExpenseDetails = (e) => {
        setIsEditLoading(true);
        api.get(`expenses/get-expense-details?expenseId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.expenseId);
            setSelectedDate(response.data.expenseDate);
            setExpenseType(response.data.expenseType);
            setAssignedTo(response.data.expenseDescription);
            setTotalPrice(response.data.expenseAmount);
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    const fetchAllExpenseTypes = useCallback( async () => {
        
        
        await api.get(`expensetypes/get-all-expense-type`,{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setAllExpenseType(response.data);
        })
        
    },[token])

    

    useEffect(() => {
        fetchAllDailyExpenses();
        fetchAllExpenseTypes();
    },[fetchAllDailyExpenses,fetchAllExpenseTypes,url])

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`expenses/create-expense`,{
            expenseDate: selectedDateObj,
            expenseType:expenseType,
            expenseDescription: assignedTo,
            expenseAmount: totalPrice,
            unitShadeId: unitShadeNo

        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllDailyExpenses();
            setIsLoading(false);
            setSelectedDate('');
            setExpenseType("");
            setAssignedTo('');
            setTotalPrice();
            setAddSale(0);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setExpenseType('');
            setAssignedTo('');
            setTotalPrice();
        })
    }


    const showAddExpense = () =>{
        fetchAllExpenseTypes();
        setAddSale(1);
    }

    const closeAddExpense = () => {
        setAllExpenseType([]);
        setAddSale(0);
    }

    const showEditSale = (e) => {
        fetchExpenseDetails(e);
        fetchAllExpenseTypes();
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        setAssignedTo('');   
        setTotalPrice(); 
        setIsEditLoading(false);
        fetchAllDailyExpenses();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`expenses/edit-expense`,{
            expenseId: saleId,
            expenseType: expenseType,
            expenseDescription: assignedTo,
            expenseAmount: totalPrice,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setExpenseType('');
            setAssignedTo('');
            setTotalPrice();
            setIsEditLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            setIsEditLoading(false);
            setSelectedDate('');
            setAssignedTo('');
            setTotalPrice();
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`expenses/delete-expense`,{
            expenseId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setAssignedTo('');
            setExpenseType('');
            setTotalPrice();
            setIsDeleteLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setAssignedTo('');
            setTotalPrice();
        })
    }
 
    return(
        <div className='dailyExpensePage'> 
    
           <LeftPanel 
                tabName='daily-expense'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Expense Description'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                            <select 
                                    required 
                                    id='chooseBox'
                                    onChange={(e) => setExpenseTypeParams(e.target.value)}
                                    value={expenseTypeParams}
                                >
                                    <option value="">All Expenses</option>
                                    {allExpenseType.map(item => (
                                        <option key={item.id} value={item.expenseTypeName}>{item.expenseTypeName}</option>
                                    ))}
                            </select>
                        </div>
                        {userRole === 'Admin' &&
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Expense</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={showAddExpense}
                            >Add Expense</button>
                       </div>}
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Expense Type</th>
                                    <th>Description</th>
                                    <th>Amount (Tk)</th>
                                    
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                                
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.expenseDate.substring(0, item.expenseDate.length - 9)}</td>
                                        <td>{item.expenseType}</td>
                                        <td>{item.expenseDescription}</td>
                                        <td>{item.expenseAmount}</td>
                                        
                                        {editSale ===1 && <td onClick={() => showEditSale(item.expenseId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddExpense}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Expense</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            
                        </div>
                        
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='multiBox'>
                                <div id='header'>Expense Type:</div>
                                <select 
                                    required 
                                    id='chooseBox'
                                    onChange={(e) => setExpenseType(e.target.value)}
                                    value={expenseType}
                                >
                                    <option value="">Choose Type</option>
                                    {allExpenseType.map(item => (
                                        <option key={item.id} value={item.expenseTypeName}>{item.expenseTypeName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='multiBox'>
                                <div id='header'>Expense Description:</div>
                                <textarea
                                    id='multilineText'
                                    placeholder='Type expense description'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Amount (Tk): </div>
                                <input
                                    id='amount'
                                    type='number'
                                    placeholder='Type amount paid'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            
                        </div>
                      
                        {isError && 
                            <div id='errorMsg'>Failed adding new expense! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Expense</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Expense</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.substring(0,selectedDate.length-9)}</div>
                            </div>
                           
                        </div>
                        <div id='namePhone'>
                            <div id='multiBox'>
                                <div id='header'>Expense Type:</div>
                                <select 
                                    required 
                                    id='chooseBox'
                                    onChange={(e) => setExpenseType(e.target.value)}
                                    value={expenseType}
                                >
                                    <option value="">Choose Type</option>
                                    {allExpenseType.map(item => (
                                        <option key={item.id} value={item.expenseTypeName}>{item.expenseTypeName}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='multiBox'>
                                <div id='header'>Expense Description:</div>
                                <textarea
                                    id='multilineText'
                                    placeholder='Type expense description'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                           
                        </div>
                        
                      
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Amount (Tk): </div>
                                <input
                                    id='amount'
                                    type='number'
                                    placeholder='Amount paid'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            
                        </div>
                     
                        {isError && 
                            <div id='errorMsg'>Failed updating expense! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting expense! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Expense</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default DailyExpense;